var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C7.178 32 0 24.822 0 16C0 7.178 7.178 0 16 0C24.822 0 32 7.178 32 16C32 24.822 24.822 32 16 32ZM16 2C8.28 2 2 8.28 2 16C2 23.72 8.28 30 16 30C23.72 30 30 23.72 30 16C30 8.28 23.72 2 16 2ZM17 9C17 9.55229 16.5523 10 16 10C15.4477 10 15 9.55229 15 9C15 8.44771 15.4477 8 16 8C16.5523 8 17 8.44771 17 9ZM16 23.9967C15.448 23.9967 15 23.5497 15 22.9967V13C15 12.448 15.448 12 16 12C16.552 12 17 12.448 17 13V22.9967C17 23.5497 16.552 23.9967 16 23.9967Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C7.178 32 0 24.822 0 16C0 7.178 7.178 0 16 0C24.822 0 32 7.178 32 16C32 24.822 24.822 32 16 32ZM16 2C8.28 2 2 8.28 2 16C2 23.72 8.28 30 16 30C23.72 30 30 23.72 30 16C30 8.28 23.72 2 16 2ZM17 9C17 9.55229 16.5523 10 16 10C15.4477 10 15 9.55229 15 9C15 8.44771 15.4477 8 16 8C16.5523 8 17 8.44771 17 9ZM16 23.9967C15.448 23.9967 15 23.5497 15 22.9967V13C15 12.448 15.448 12 16 12C16.552 12 17 12.448 17 13V22.9967C17 23.5497 16.552 23.9967 16 23.9967Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/Info_Icon.1d08e96e2dcfc0e1524a5e43b45ff698.svg";
export { ForwardRef as ReactComponent };